import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // get parent user
  getParantUser: async ({ commit }) => {
    // set loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get('/lab-test/parent-user')

      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      
      // set parent user
      commit('SET_STATE', {
        action: 'parent_user',
        data: res.data.user
      })

      return {
        data: res.data.user
      }
    } catch (err) {
      // set loading
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add lab test
  addLabTest: async ({commit}, payload) => {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    // send lab test request
    try {
      const res = await axios.post('/lab-test', payload)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get all lab test
  getLabTest: async ({commit}, payload) => {
    const { limit, page, order, search, pending, labAdmin } = payload
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    
    try {
      const res = await axios.get('/lab-test', {
        params: {
          limit,
          page,
          order,
          search,
          pending,
          labAdmin
        }
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      
      commit('SET_STATE', {
        action: 'lab_tests',
        data: res.data.data
      })
      
      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.FilteredCount
      })
      return {
        data: res.data.data,
        FilteredCount: res.data.FilteredCount,
        total: res.data.totalCount
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add lab test note
  addLabTestNote: async ({commit}, data) => {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    
    const {id, note} = data

    // send lab test request
    try {
      const res = await axios.put(`/lab-test/${id}/update-note`, {note})

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update status lab test
  updateLabTeststatus: async ({commit}, data) => {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    
    const {id, status} = data

    // send lab test request
    try {
      const res = await axios.put(`/lab-test/${id}/update-status`, {status})

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get all lab test by id
  getLabTestById: async ({commit}, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    
    try {
      const res = await axios.get(`/lab-test/${id}`)
      
      commit('SET_STATE', {
        action: 'lab_test',
        data: res.data.labTest
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      
      return {
        data: res.data.labTest
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update lab test
  updateLabTest: async ({commit}, payload) => {
    // start loading
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    const {id, data} = payload

    // send lab test request
    try {
      const res = await axios.put(`/lab-test/${id}`, data)

      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // return api response
      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      // stop loader
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // manage error response
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }

}